import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import {
  headingFonts,
  textFieldStyles,
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../Styles/Styles";

export default function IDRejectReasonModal({
  open,
  onClose,
  reason,
  setReason,
  onConfirm,
}) {
  const handleReasonChange = (e) => {
    setReason(e.target.value); // Ensure the state is being updated in the parent component
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ ...headingFonts }}>Rejection Reason</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Reason"
          value={reason} // Pass the reason to the value prop
          onChange={handleReasonChange} // Handle change in the modal
          multiline
          rows={3}
          sx={{ ...textFieldStyles, mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ ...secondaryButtonStyles }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} sx={{ ...primaryButtonStyles }}>
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}
